import { setCookie } from '../../utils/setCookie';

export const getRedirectUrl = (): string => {
  const ssoUrl = atob(process.env.REACT_APP_SSO);
  const clientId = atob(process.env.REACT_APP_CLIENT_ID);
  return `${ssoUrl}/govbr/authorize/?client_id=${clientId}`;
};

export const handleSelectCertificadoDigital = (pathname: string) => {
  const clientId = atob(process.env.REACT_APP_CLIENT_ID);
  const schemeHost = atob(process.env.REACT_APP_CONTROL_LOGIN_URL);
  setCookie('pathname_redirect_gov', pathname, 7);
  const url = `${schemeHost}/auth/ssl-client/?client_id=${clientId}&origin=public`;

  window.location.href = url;
};
